// initialize whole foundation
$(document).foundation();

$(function () {
	// initialize nette ajax plugin
	$.nette.init();
	window.NProgress.configure({showSpinner: false});

	// verify javascript while signing in to game (it's used to check coordinates)
	$('input[name=js]', $('#frm-signInForm')).val(1);

	// initialize gps checker
	if (window.brko.gpsReportingUrl) {
		window.brko.gpsChecker.start({reportingUrl: window.brko.gpsReportingUrl});
	}

	// initialize all count downs on page
	window.brko.countdown.init();

	// initialize confirmation dialogs
	window.brko.confirmation.init(Foundation.utils.S('#confirmationDialog'));

	// initialize choosing sites from map
	window.brko.mapWidget({mapContainerId: "chooseMap"});
	// initialize map for verifying location
	window.brko.mapWidget({mapContainerId: "locationMap"});

	// initialize 360 photos
	window.brko.pannellum();

	// initialize image slider (before/after images)
	window.brko.imageSlider();
});
